module.exports = __webpack_public_path__ + "media/images/v3/thumb2-d208b4ac5d595a8966c2de649c2e190c.png";